import { render, staticRenderFns } from "./StudentProgram.vue?vue&type=template&id=671665f1&scoped=true&"
import script from "./StudentProgram.vue?vue&type=script&lang=js&"
export * from "./StudentProgram.vue?vue&type=script&lang=js&"
import style0 from "./StudentProgram.vue?vue&type=style&index=0&id=671665f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671665f1",
  null
  
)

export default component.exports